import { IState } from 'legacy/lut/store'

export const selectMdfActivitiesState = (state: IState) => state.partner360.mdfActivities
